export interface CreditQuota {
    tier: string;
    frequency: 'monthly' | 'annual';
    isCommission: boolean;
    quota: number;
    displayName: string;
}

/**
 * Credit quotas for the 5 actual subscription plans:
 * - Premium Annual (no commission): 600 credits/year
 * - Premium Annual (with commission): 300 credits/year
 * - Pro Monthly (no commission): 100 credits/month
 * - Pro Monthly (with commission): 50 credits/month
 * - Pro Annual (no commission): 1500 credits/year
 * - Pro Annual (with commission): 750 credits/year
 */
export const CREDIT_QUOTAS: CreditQuota[] = [
    {
        tier: 'tier1',
        frequency: 'annual',
        isCommission: false,
        quota: 600,
        displayName: 'Premium Annual'
    },
    {
        tier: 'tier1',
        frequency: 'annual',
        isCommission: true,
        quota: 300,
        displayName: 'Premium Annual (Commission)'
    },
    {
        tier: 'tier2',
        frequency: 'monthly',
        isCommission: false,
        quota: 100,
        displayName: 'Pro Monthly'
    },
    {
        tier: 'tier2',
        frequency: 'annual',
        isCommission: false,
        quota: 1500,
        displayName: 'Pro Annual'
    },
    {
        tier: 'tier2',
        frequency: 'monthly',
        isCommission: true,
        quota: 50,
        displayName: 'Pro Monthly (Commission)'
    },
    {
        tier: 'tier2',
        frequency: 'annual',
        isCommission: true,
        quota: 750,
        displayName: 'Pro Annual (Commission)'
    }
];

export class CreditQuotaHelper {
    /**
     * Get credit quota for a given tier, frequency and commission status
     * @param tier - Subscription tier (tier0, tier1, tier2)
     * @param frequency - Billing frequency (monthly, annual)
     * @param isCommission - Whether the plan has commission (sellerCommissionPercent > 0)
     * @returns Credit quota amount, or 0 if not found (tier0/basic returns 0)
     */
    static getQuota(tier: string, frequency: string, isCommission: boolean = false): number {
        const quota = CREDIT_QUOTAS.find(
            q => q.tier === tier && q.frequency === frequency && q.isCommission === isCommission
        );
        return quota ? quota.quota : 0;
    }

    /**
     * Get display name for a given tier, frequency and commission status
     * @param tier - Subscription tier (tier0, tier1, tier2)
     * @param frequency - Billing frequency (monthly, annual)
     * @param isCommission - Whether the plan has commission
     * @returns Display name, or 'Basic' if not found
     */
    static getDisplayName(tier: string, frequency: string, isCommission: boolean = false): string {
        const quota = CREDIT_QUOTAS.find(
            q => q.tier === tier && q.frequency === frequency && q.isCommission === isCommission
        );
        return quota ? quota.displayName : 'Basic';
    }
}
